import React, { useEffect, useState, useMemo, useCallback } from "react";
import editIcon from "../assets/edit.png";
import { getEmployeeDetails } from "../api/employeesApi";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";

const ManageEmpDetails = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/manage-employee/edit-employee");
  };

  const companyId = "com_affa65d93030f0118b3d6045bdc7c627";
  const employeeId = "emp_55b194e8f530f0118b3d6045bdc7c627";
  const [employee, setEmployee] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await getEmployeeDetails(companyId, employeeId);
        if (res?.data && typeof res.data === "object") {
          setEmployee(res.data);
        } else {
          console.error("Invalid response structure:", res);
        }
      } catch (error) {
        console.error("Error fetching employee details:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [companyId, employeeId]);

  const formatDate = useCallback((dateStr) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    return isNaN(date)
      ? "-"
      : date.toLocaleDateString("en-US", {
          year: "numeric",
          month: "short",
          day: "2-digit",
        });
  }, []);

  const fullAddress = useMemo(() => {
    if (!employee?.residence) return "-";
    const { street1, city, state, zipcode, country } = employee.residence;
    return [street1, city, state, zipcode, country].filter(Boolean).join(", ");
  }, [employee]);

  const workplaceAddress = useMemo(() => {
    if (!employee?.workplaces?.length || !employee.primaryWorkplaceId)
      return "-";
    const primaryWorkplace = employee.workplaces.find(
      (wp) => wp.id === employee.primaryWorkplaceId
    );
    if (!primaryWorkplace || !primaryWorkplace.address) return "-";
    const { street1, city, state, zipcode, country } = primaryWorkplace.address;
    return [street1, city, state, zipcode, country].filter(Boolean).join(", ");
  }, [employee]);

  // if (loading) return <div className='p-4'>Loading employee data...</div>;

  // if (!employee) return <div className='p-4 text-danger'>Employee not found or invalid response.</div>;

  return (
    <div className="p-4">
      <h4 className="mb-2 main-title-for-all">Manage Employee Profile</h4>
      <p className="gray-text-for-content mb-4">
        Select a step below to view or make changes.
      </p>
      {loading ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "20%",
          }}
        >
          <Spinner animation="border" />
        </div>
      ) : (
        <div className="mb-4 p-4 bg-white rounded">
          <div className="mb-4">
            <h5 className="sub-title">
              Employee Id :
              <span
                className="ms-4 gray-text-for-content"
                style={{
                  fontWeight: "400",
                  background: "#F8F8F8",
                  borderRadius: "20px",
                  padding: "7px 20px",
                }}
              >
                {employee?.id}
                <img
                  src={editIcon}
                  style={{ width: "14px", margin: "-4px 0px 0px 12px" }}
                  onClick={handleClick}
                  alt="edit"
                />
              </span>
            </h5>
            <div
              className="row"
              style={{
                border: "1px solid #C4C4C480",
                borderRadius: "10px",
                padding: "30px 20px",
                margin: "22px 6px 0px 6px",
              }}
            >
              <div className="col-4">
                <p className="gray-text-for-content mb-2">Onboard Status</p>
                <button className="yellow-button">
                  {employee?.onboard?.status || "N/A"}
                </button>
              </div>
              <div className="col-4">
                <p className="gray-text-for-content mb-2">Active Status</p>
                <button className="green-button">
                  {employee?.active ? "Active" : "Inactive"}
                </button>
              </div>
            </div>
          </div>

          <div className="mb-4">
            <h5 className="sub-title">General Information</h5>
            <div
              className="row "
              style={{
                border: "1px solid #C4C4C480",
                borderRadius: "10px",
                padding: "22px 20px",
                margin: "22px 3px 0px 3px",
              }}
            >
              <div className="col-4 p-0">
                <p className="gray-text-for-content  mb-1">First Name</p>
                <p className="information-text mb-3">
                  {employee?.firstName || "-"}
                </p>
              </div>
              <div className="col-4 p-0">
                <p className="gray-text-for-content mb-1">Middle Name</p>
                <p className="information-text mb-3">
                  {employee?.middleName || "-"}
                </p>
              </div>
              <div className="col-4 p-0">
                <p className="gray-text-for-content mb-1">Last Name</p>
                <p className="information-text mb-3">
                  {employee?.lastName || "-"}
                </p>
              </div>
              <div className="col-4 p-0">
                <p className="gray-text-for-content mb-1">Payment Method</p>
                <p className="information-text mb-3">
                  {employee?.defaultPaymentMethod || "-"}
                </p>
              </div>
              <div className="col-4 p-0">
                <p className="gray-text-for-content mb-1">SSN</p>
                <p className="information-text mb-3">
                  •••••••••{employee?.ssnLastFour || "XXXX"}
                </p>
              </div>
              <div className="col-4 p-0">
                <p className="gray-text-for-content mb-1">Date of Birth</p>
                <p className="information-text mb-3">
                  {formatDate(employee?.dateOfBirth) || "-"}
                </p>
              </div>
              <div className="col-4 p-0">
                <p className="gray-text-for-content mb-1">Start Date</p>
                <p className="information-text  mb-3">
                  {formatDate(employee?.startDate) || "-"}
                </p>
              </div>
              <div className="col-4 p-0">
                <p className="gray-text-for-content mb-1">Termination Date</p>
                <p className="information-text mb-3">
                  {formatDate(employee?.terminationDate) || "-"}
                </p>
              </div>
            </div>
          </div>

          <div className="mb-4">
            <h5 className="sub-title">Contact Information</h5>
            <div
              className="row "
              style={{
                border: "1px solid #C4C4C480",
                borderRadius: "10px",
                padding: "22px 20px",
                margin: "22px 3px 0px 3px",
              }}
            >
              <div className="col-4 p-0">
                <p className="gray-text-for-content  mb-1">Residence</p>
                <p className="information-text mb-3">{fullAddress || "-"}</p>
              </div>
              <div className="col-4 p-0">
                <p className="gray-text-for-content mb-1">Email</p>
                <p className="information-text mb-3">
                  {employee?.email || "-"}
                </p>
              </div>
            </div>
          </div>

          <div className="mb-4">
            <h5 className="sub-title">Workplace Information</h5>
            <div
              className="row "
              style={{
                border: "1px solid #C4C4C480",
                borderRadius: "10px",
                padding: "22px 20px",
                margin: "22px 3px 0px 3px",
              }}
            >
              <div className="col-4 p-0">
                <p className="gray-text-for-content  mb-1">Primary Workplace</p>
                <p className="information-text mb-3">
                  {workplaceAddress || "-"}
                </p>
              </div>
              <div className="col-4 p-0">
                <p className="gray-text-for-content mb-1">Department</p>
                <p className="information-text mb-3">
                  {employee?.department?.name || "No Department Assigned"}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ManageEmpDetails;
